import { createApi } from '@reduxjs/toolkit/query/react'

import { getCustomFetch } from '@/shared/api/custom-fetch-base'

import { IOrganization } from '../model/types'

const baseUrl = '/organizations/'

export const organizationApi = createApi({
  reducerPath: 'organizationApi',
  baseQuery: getCustomFetch(),
  tagTypes: ['organization'],
  endpoints: build => ({
    organizationList: build.query<IOrganization[], void>({
      query: () => ({
        url: baseUrl,
        method: 'GET',
      }),
      providesTags: ['organization'],
    }),

    createOrganization: build.mutation<IOrganization, Partial<IOrganization>>({
      query: body => ({ url: baseUrl, method: 'POST', body }),
      invalidatesTags: ['organization'],
    }),

    updateOrganization: build.mutation<
      IOrganization,
      { id: number | string; body: Partial<IOrganization> }
    >({
      query: ({ id, body }) => ({
        url: baseUrl + id.toString(),
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['organization'],
    }),

    removeOrganization: build.mutation<unknown, string>({
      query: id => ({ url: baseUrl + id.toString(), method: 'DELETE' }),
      invalidatesTags: ['organization'],
    }),
  }),
})

export const {
  useOrganizationListQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
  useRemoveOrganizationMutation,
} = organizationApi
